import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';

import * as ProcedureCreditedActions from './procedure-credited.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';
import { Subscription } from 'rxjs';
import { User } from 'src/app/components/catalogs/user-catalog/services/user';
import { AppStateService } from 'src/app/store/app-state-service';
import { MissingTrainingRefresh } from '../procedure-missing-training/procedure-missing-training.action';

@Injectable({
  providedIn: 'root'
})
export class ProcedureCreditedStoreAndListenersService {
  currentUser?: User | null;
  subscription!: Subscription;
  constructor(private store: Store, private signalRService: SignalRService, private ass: AppStateService) { }
  initStore() {
    this.store.dispatch(new ProcedureCreditedActions.ProcedureCreditedRefresh());
    this.subscription = this.ass.AppState.subscribe(appState => {
      this.currentUser = appState.currentUser;
    });
  }

  initListeners() {
    // ABSI
    this.signalRService.hubConnection?.on(Channels.PROCEDURECREDITED, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new ProcedureCreditedActions.ProcedureCreditedCreate(data.obj));
          this.store.dispatch(new MissingTrainingRefresh(this.currentUser?.id ?? 0));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new ProcedureCreditedActions.ProcedureCreditedUpdate(data.id, data.obj));
          this.store.dispatch(new MissingTrainingRefresh(this.currentUser?.id ?? 0));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new ProcedureCreditedActions.ProcedureCreditedDelete(data.id));
          this.store.dispatch(new MissingTrainingRefresh(this.currentUser?.id ?? 0));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new ProcedureCreditedActions.ProcedureCreditedRefresh());
          this.store.dispatch(new MissingTrainingRefresh(this.currentUser?.id ?? 0));
      }
    });

  }
}
